import React, { useEffect } from "react"
import './App.css'
import Routes from './Routes'
import Header from './components/header/Header'
// import PersistentDrawerLeft from './components/header/NewHeader'
import Footer from './components/Footer'
import useUser from './hooks/useUser'
import { useGeneral } from './context/general'
import history from './history'
import SnackbarAlert from './components/ui/SnackbarAlert'
import {ErrorBoundary} from 'react-error-boundary'
import RouteErrorPage from './components/RouteErrorPage'

history.listen((location, action) => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
})

export default function MainApp () {
    const { alertOpen, alert, handleCloseAlert } = useGeneral()
    const { logoutAllTabsEventListener } = useUser() 
  
    useEffect(()=>{
      logoutAllTabsEventListener()
      return () => {}
    },[logoutAllTabsEventListener])
  
    return (
        <div className='App'>
            <SnackbarAlert isOpen={alertOpen} alert={alert} handleClose={handleCloseAlert} />
            <Header />
            {/* <PersistentDrawerLeft /> */}
            <div className='content'>
              <div className='contentApp'>
                <ErrorBoundary FallbackComponent={RouteErrorPage} >
                  <Routes />
                </ErrorBoundary>
              </div>
            </div>
            <Footer />
        </div>
    )
  }